// @ts-nocheck
import { HasOnComplete } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    submitContactUsTopicsForm,
    SubmitContactUsTopicsFormApiParameter,
    SubmitContactUsTopicsFormModel,
} from "@store/Framework/Services/ContactUsTopicsService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type ApiResult = SubmitContactUsTopicsFormModel;
type ApiParameter = SubmitContactUsTopicsFormApiParameter;
type Parameter = ApiParameter & HasOnSuccess<ApiResult> & HasOnError<string> & HasOnComplete<void>;

type HandlerType = ApiHandlerDiscreteParameter<Parameter, ApiParameter, ServiceResult<ApiResult>>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, onComplete, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await submitContactUsTopicsForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const ExecuteOnCompleteCallback: HandlerType = props => {
    props.parameter.onComplete?.();
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
    ExecuteOnCompleteCallback,
];

const submitForm = createHandlerChainRunner(chain, "SubmitForm");
export default submitForm;
